module.exports = __webpack_public_path__ + "assets/asset_oilrig.3697b649.svg";